export const TOKEN_NAME = 'JwtToken';
export const SYSTEM_ACCESS = 'sys_access';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const LAYOUT = 'layout';
export const GROUPING = 'grouping';
export const THEORY = 'theory';
export const VIVA = 'Viva';
export const PRACTICAL = 'Practical';
export const MODULE = 'module';
export const DIFFICULTY = 'difficulty';
export const MARKS = 'marks';
export const COURSE = 'Course';
// export const SCHEME = 'Scheme';
export const PROJECT = 'Project';
export const CUSTOMER = 'Customer';
export const WARM = 'Warm';
export const COLD = 'Cold';
export const LEAD = 'lead';
export const TAGS = 'tags';
export const ATTRIBUTES = 'attributes';
export const CLOSED = 'Closed';
export const EDIT = 'edit';
export const CLOSE = 'close';
export const DROP = 'drop';
export const UPDATE = 'update';
export const OPEN = 'Open';
export const DROPPED = 'Dropped';
export const DISABLED = 'Disabled';
export const DEALS = 'Deals';
export const OTHERS = 'Others';
export const OPPORTUNITIES = 'Opportunities';
export const ASSESSMENTS = 'Assessments';
export const QUESTION_PAPER_VERSIONS = 'Question Paper Versions';
export const LOGO_ASPECT_RATIO_VALIDATION =
  'The image aspect ratio must be greater than 1.5. Please try uploading a different image. (Ex. Width: 3000, Height: 1500)';
export const LOGO_SIZE_LIMIT = 5000000;
export const LOGO_FILE_SIZE_VALIDATION =
  'The image size cannot be more than 2mb.';
export const USERS = 'users';
export const MATCH_THE_FOLLOWING = 'Matching Questions';
export const MULTIPLE_CHOICE = 'Multiple Choice Question';
export const TRUE_OR_FALSE = 'True/False Question';
export const MULTI_SELECT = 'Multi-select Question';
export const FILL_IN_THE_BLANKS = 'Fill In The Blanks Question';
export const SUBJECTIVE = 'Subjective Answer Question';
export const ACTIVITY = 'Activity';
export const SCENARIO_BASED_QUESTION = 'Scenario Based Question';
export const DELETE_CONFIRMATION =
  'This action will delete the selected entry and will remove the entry from the list screen. Are you sure, you want to proceed with this action?';
export const DEFAULT_LANGUAGE_CODE = 'En';
export const INSUFFICIENT_QUESTIONS_ERROR =
  'You have insufficient questions in the category - $1 to generate the question paper. Please try again by modifying the criteria or by adding more questions.';
export const PERCENTAGE_TOTAL_HELP_TEXT =
  'The sum of percentages for Easy, Medium, Difficult should not exceed 100%.';
export const CATEGORY_COUNT_REQUIRED =
  'Please add count of questions for the category - ${obj.category}';
export const NO_PREVIEW = 'Question too big to display';
export const TABLE_COLUMN_CHARACTER_LIMIT = 95; 
export const PREVIEW_CHARACTER_LIMIT = 120;
export const QUESTION_CATEGORY_LIST: any = [
  {
    category_name: 'theory',
  },
  {
    category_name: 'practical',
  },
  {
    category_name: 'viva',
  },
];

export const DIFFICULTY_LEVEL_LIST = [
  { level: 'Easy' },
  { level: 'Medium' },
  { level: 'Difficult' },
];

export const GROUPING_CRITERIA_LIST = [
  { criteria: 'Label-Level 1', id: 'module' },
  { criteria: 'Difficulty Level', id: 'difficulty' },
  { criteria: 'Marks', id: 'marks' }
];

export const EVALUATION_GROUPING_CRITERIA_LIST = [
  { criteria: 'Label-Label 1', id: 'module' },
  { criteria: 'Difficulty Level', id: 'difficulty' },
];

export const QUESTION_SELECTION_METHOD_LIST = [
  { name: 'Manual import', id: 'manual', icon: 'input' },
  { name: 'Automated selection', id: 'automated', icon: 'autorenew' },
];

export const QUESTION_PAPER_PREVIEW_LIST = [
  { name: 'View 1 question per page', id: 'multiPage' },
  { name: 'View all questions in a page', id: 'onePage' },
];

export const student_metadata = [
  { key: 'Student Name', value: 'Jane Doe' },
  { key: 'Student Id', value: 1234453 },
  { key: 'Duration', value: '02:00:00' },
  { key: 'Test Date', value: '05/06/2023' },
];

export const questionsSample = [
  {
    question_id: 62,
    question_text: '<p>Which soil is derived from basaltic rock?</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '<p>Test addition information</p>',
    question_type_id: 1,
    question_type_name: 'Multiple Choice Question',
    difficulty_level_id: 1,
    difficulty_level_name: 'Easy',
    marks: 1,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: 'Question_202210111665488026346.png',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '<p>Test hint for question</p>',
    question_feedback: 'test additional feedback',
    question_remarks: 'test answer explanation',
    question_category: 'theory',
    module: 'mod-a',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
    options: ['Option 1', 'Option 2', 'Option 3', 'Option 4'],
  },
  {
    question_id: 64,
    question_text: '<p>Fill in the blanks</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '',
    question_type_id: 3,
    question_type_name: 'Fill In The Blanks Question',
    difficulty_level_id: 2,
    difficulty_level_name: 'Medium',
    marks: 2,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: '',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '',
    question_feedback: '',
    question_remarks: '',
    question_category: 'theory',
    module: 'mod-a',
    language_count: 0,
    fill_up_id: 9,
    actual_statement_text:
      '<p>Roses are [red] and voilets are [blue]. Please fill.</p>',
    blank_indices_start_end_data: [
      {
        start_index: 13,
        end_index: 17,
        blank_text: '[red]',
      },
      {
        start_index: 35,
        end_index: 40,
        blank_text: '[blue]',
      },
    ],
    count_of_blanks: 2,
    blank_text_ans_key_data: {
      '1': 'black<br>yellow',
      '2': 'black<br>grey',
    },
  },
  {
    question_id: 67,
    question_text: '<p>Subjective answers questions</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '',
    question_type_id: 5,
    question_type_name: 'Subjective Answer Question',
    difficulty_level_id: 2,
    difficulty_level_name: 'Medium',
    marks: 20,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: '',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: 22,
    sample_answer_for_reference: '<p>Test sample answer</p>',
    answer_keywords: 'test,subjective',
    evaluation_remarks: 'Test evaluation remarks',
    initial_text: 'Test initial text',
    question_hint: '',
    question_feedback: '',
    question_remarks: '',
    question_category: 'theory',
    module: 'mod-b',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
  },
  {
    question_id: 83,
    question_text: '<p>Match the following test question:</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '',
    question_type_id: 4,
    question_type_name: 'Match The Following Question',
    difficulty_level_id: 2,
    marks: 3,
    difficulty_level_name: 'Medium',
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: '',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '',
    question_feedback: '',
    question_remarks: '',
    question_category: 'theory',
    module: 'mod-a',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
    primary_list: ['Danke', 'Bitte', 'Hund'],
    secondary_list: ['Dog', 'Thank you', 'Please'],
  },
  {
    question_id: 63,
    question_text: '<p>The atomic number for lithium is 17.</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '<p>Test addition information</p>',
    question_type_id: 2,
    question_type_name: 'True/False Question',
    difficulty_level_id: 1,
    difficulty_level_name: 'Easy',
    marks: 1,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: 'Question_202210111665488026346.png',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '<p>Test hint for question</p>',
    question_feedback: 'test additional feedback',
    question_remarks: 'test answer explanation',
    question_category: 'theory',
    module: 'mod-b',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
  },
  {
    question_id: 68,
    question_text: '<p>Choose all examples of types of carbohydrates.</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '<p>Test addition information</p>',
    question_type_id: 6,
    question_type_name: 'Multiple Choice Question',
    difficulty_level_id: 1,
    difficulty_level_name: 'Easy',
    marks: 3,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: 'Question_202210111665488026346.png',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '<p>Test hint for question</p>',
    question_feedback: 'test additional feedback',
    question_remarks: 'test answer explanation',
    question_category: 'theory',
    module: 'mod-b',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
    options: [
      'Option 1',
      'Option 2',
      'Option 3',
      'Option 4',
      'Option 5',
      'Option 6',
      'Option 7',
    ],
    no_of_answers: 3,
  },
  {
    question_id: 69,
    question_text: '<p>Choose all examples of types of carbohydrates.</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '<p>Test addition information</p>',
    question_type_id: 6,
    question_type_name: 'Multiple Choice Question',
    difficulty_level_id: 1,
    difficulty_level_name: 'Easy',
    marks: 3,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: 'Question_202210111665488026346.png',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '<p>Test hint for question</p>',
    question_feedback: 'test additional feedback',
    question_remarks: 'test answer explanation',
    question_category: 'theory',
    module: 'mod-b',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
    options: [
      'Option 1',
      'Option 2',
      'Option 3',
      'Option 4',
      'Option 5',
      'Option 6',
      'Option 7',
    ],
    no_of_answers: 3,
  },
  {
    question_id: 70,
    question_text: '<p>What is aptitude, logical test? </p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '<p>Test addition information</p>',
    question_type_id: 7,
    question_type_name: 'Activity - Performance Task',
    difficulty_level_id: 1,
    difficulty_level_name: 'Easy',
    marks: 20,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: 'Question_202210111665488026346.png',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '<p>Test hint for question</p>',
    question_feedback: 'test additional feedback',
    question_remarks: 'test answer explanation',
    question_category: 'viva',
    module: 'mod-b',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
  },
  {
    question_id: 71,
    question_text: '<p>Give examples of team work.</p>',
    question_bank_id: 7,
    question_bank_title: 'TITILE 1 UPDATED',
    additional_information: '<p>Test addition information</p>',
    question_type_id: 9,
    question_type_name: 'Activity - Real Time Video',
    difficulty_level_id: 3,
    difficulty_level_name: 'Difficult',
    marks: 20,
    language_id: 1,
    language_name: 'English',
    default_language_question_id: -1,
    attachments: 'Question_202210111665488026346.png',
    is_archived: false,
    tags: '',
    course_group_label: 'Sector',
    course_subgroup_label: 'Sub-Sector',
    course_version_id: 48,
    subjective_answer_id: null,
    sample_answer_for_reference: null,
    answer_keywords: null,
    evaluation_remarks: null,
    initial_text: null,
    question_hint: '<p>Test hint for question</p>',
    question_feedback: 'test additional feedback',
    question_remarks: 'test answer explanation',
    question_category: 'viva',
    module: 'mod-a',
    language_count: 0,
    fill_up_id: null,
    actual_statement_text: null,
    blank_indices_start_end_data: null,
    count_of_blanks: null,
    blank_text_ans_key_data: null,
  },
];

export const QUESTION_TYPES = {
  1: 'multipleChoice',
  2: 'trueOrFalse',
  3: 'fillInTheBlanks',
  4: 'matchTheFollowing',
  5: 'subjective',
  6: 'multiSelect',
};

export const LANGUAGES = [
  { id: 'eng', name: 'English' },
  { id: 'hin', name: 'Hindi' },
  { id: 'kan', name: 'Kannada' },
  { id: 'tam', name: 'Tamil' },
  { id: 'tel', name: 'Telugu' },
  { id: 'mal', name: 'Malayalam' },
];

export const NOTIFICATIONS_LIST = [
  {
    createdAt: '2023-05-25T08:48:00.000Z',
    notifier: 'Admin',
    header: 'New Organization Created',
    text: 'TestOrg has just been created! Log in to your account at testorg.in to start using the platform.',
    url: '',
    read: false,
  },
  {
    createdAt: '2023-05-24T14:48:00.000Z',
    notifier: 'Admin',
    header: 'Opportunity Created',
    text: 'A new opportunity has been created for you. Please login to your account to view and manage the opportunity.',
    url: '/Customer/Opportunities',
    read: false,
  },
  {
    createdAt: '2023-05-13T12:48:00.000Z',
    notifier: 'Admin',
    header: 'New Lead Created',
    text: "Congratulations! You've just generated a new lead. Contact them ASAP to seal the deal.",
    url: '/Customer/Leads',
    read: true,
  },
  {
    createdAt: '2023-05-22T12:48:00.000Z',
    notifier: 'Admin',
    header: 'Opportunity Created',
    text: 'A new opportunity has been created for you. Please login in your account to view and manage the opportunity.',
    url: '/Customer/Opportunities',
    read: true,
  },
  {
    createdAt: '2023-05-22T12:48:00.000Z',
    notifier: 'Admin',
    header: 'New Lead Created',
    text: "Congratulations! You've just generated a new lead. Contact them ASAP to seal the deal.",
    url: '/Customer/Leads',
    read: true,
  },
  {
    createdAt: '2023-05-22T12:48:00.000Z',
    notifier: 'Admin',
    header: 'New Organization Created',
    text: 'TestOrg has just been created! Log in to your account at testorg.in to start using the platform.',
    url: '',
    read: true,
  },
  {
    createdAt: '2023-05-01T12:48:00.000Z',
    notifier: 'Sys-Admin',
    header: 'Opportunity Created',
    text: 'A new opportunity has been created for you. Please login in your account to view and manage the opportunity.',
    url: '/Customer/Opportunities',
    read: true,
  },
];

export const listOfPivotsHaveAccessToAdditionalPivotsBasedOnServices = {
  Assessment: [
    'Per Candidate',
    'Per Instance',
    'Per Course version',
    'Per Scheme',
    'Per Project',
    'Mode of delivery(Online/Offline/Hybrid)',
  ],

  Certification: [
    'Per Candidate',
    'Per Instance',
    'Per Course version',
    'Per Scheme',
    'Per Project',
    'Mode of delivery(Online/Offline/Hybrid)',
  ],

  Training: [
    'Per Candidate',
    'Per Training',
    'Per Course version',
    'Per Scheme',
    'Per Project',
    'Mode of delivery(Online/Offline/Hybrid)',
  ],

  Counselling: [
    'Per Candidate',
    'Per Instance',
    'Per Course version',
    'Per Scheme',
    'Per Project',
    'Mode of delivery(Online/Offline/Hybrid)',
  ],

  Platform: [
    'Per Candidate',
    'Per Instance',
    'Per Course version',
    'Per Scheme',
    'Per Project',
    'Mode of delivery(Online/Offline/Hybrid)',
  ],
};

export const ASSESSMENT = 'Assessment';
export const CERTIFICATION = 'Certification';
export const TRAINING = 'Training';
export const COUNSELLING = 'Counselling';
export const PLATFORM = 'Platform';
export const ADDITIONAL_PIVOT = 'additionalPivot';

export const servicesWithPivots = [
  'Assessment',
  'Certification',
  'Training',
  'Counselling',
  'Platform',
];

export const servicesWithoutPivots = [
  'Manpower',
  'Content',
  'Data entry',
  'Reimbursement',
];

export const listOfPivots = [
  { id: 0, title: 'Per Candidate' },
  { id: 1, title: 'Per Instance' },
  { id: 2, title: 'Per Course version' },
  { id: 3, title: 'Per Scheme' },
  { id: 4, title: 'Per Project' },
  { id: 5, title: 'Mode of delivery(Online/Offline/Hybrid)' },
  { id: 6, title: 'Flat rate' },
  { id: 7, title: 'Per Training' },
];

export const listOfAdditionalPivots = [
  { id: 0, title: 'Planned' },
  { id: 1, title: 'Present' },
];

export const listOfPivotsBasedOnSelectedService = {
  Assessment: [0, 1, 2, 3, 4, 5, 6],
  Certification: [0, 1, 2, 3, 4, 5, 6],
  Training: [0, 7, 2, 3, 4, 5, 6],
  Counselling: [0, 3, 4, 5, 6],
  Platform: [0, 1, 6],
};

export const listOfServices = [
  { id: 0, title: 'Assessment' },
  { id: 1, title: 'Certification' },
  { id: 2, title: 'Training' },
  { id: 3, title: 'Counselling' },
  { id: 4, title: 'Platform' },
  { id: 5, title: 'Manpower' },
  { id: 6, title: 'Content' },
  { id: 7, title: 'Data entry' },
  { id: 8, title: 'Reimbursement' },
  { id: 9, title: 'Others' },
];

export const listOfOtherServices = [{ id: 9, title: 'Not covered' }];

export const listOfNames = [
  { id: 0, title: 'Mrinal' },
  { id: 1, title: 'Dinesh' },
  { id: 2, title: 'Prabhash' },
  { id: 3, title: 'Babu' },
  { id: 4, title: 'NagaJyothi' },
  { id: 5, title: 'Vinod' },
  { id: 6, title: 'Vijay' },
];

export const listOfFlatRateTypes = [
  { id: 1, title: 'Per Candidate' },
  { id: 2, title: 'Per Instance' },
];

export const listOfDurationTypes = [
  { id: 0, title: 'Monthly' },
  { id: 1, title: 'Quarterly' },
  { id: 2, title: 'Yearly' },
];

export const listOfFeeTypeForServicesWithoutPivots = [
  { id: 0, title: 'One-Time Fee' },
  { id: 1, title: 'Recurring Fee' },
];

export interface RateMasterElement {
  s_no: number;
  customer: string;
  serviceType: string;
  uom: string;
  unitRate: string;
  effectiveFrom: string;
  effectiveTo: string;
  is_archived: string;
}

export interface RateMasterOriginalElement {
  s_no: number;
  customer: string;
  serviceType: string;
  uom: string;
  additionalPivot: string;
  unitRate: string;
  effectiveFrom: string;
  effectiveTo: string;
  is_archived: string;
}

const ORIGINAL_DATA: RateMasterOriginalElement[] = [
  {
    s_no: 1,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '05-Jun-2023',
    effectiveTo: '06-Jun-2023',
    is_archived: 'false',
  },
  {
    s_no: 2,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '01-Jun-2023',
    effectiveTo: '05-Jun-2023',
    is_archived: 'false',
  },
  {
    s_no: 3,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '12-Jun-2023',
    effectiveTo: '14-Jun-2023',
    is_archived: 'false',
  },
  {
    s_no: 4,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '16-Jun-2023',
    effectiveTo: '18-Jun-2023',
    is_archived: 'false',
  },
  {
    s_no: 5,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },

  {
    s_no: 6,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },
  {
    s_no: 7,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },
  {
    s_no: 8,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },
  {
    s_no: 9,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },

  {
    s_no: 10,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },
  {
    s_no: 11,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },
  {
    s_no: 12,
    customer: 'Amity',
    serviceType: 'Assessment',
    uom: 'avasd',
    additionalPivot: 'Per Candidate',
    unitRate: '4200',
    effectiveFrom: '14-Jul-2023',
    effectiveTo: '14-Jul-2023',
    is_archived: 'false',
  },
];

export const RATE_MASTER_ELEMENT_DATA: RateMasterElement[] = ORIGINAL_DATA.map(
  (item) => ({
    s_no: item.s_no,
    customer: item.customer,
    serviceType: item.serviceType,
    uom: `${item.uom}/${item.additionalPivot}`,
    unitRate: item.unitRate,
    effectiveFrom: item.effectiveFrom,
    effectiveTo: item.effectiveTo,
    is_archived: item.is_archived,
  })
);

export const EVALUATION_TAG_TYPES = [
  'Customer',
  'Project',
  'Custom',
];

export const customers = ['Customer 1', 'Customer 2'];
// export const schemes = ['Scheme 1', 'Scheme 2'];
export const courses = ['Course 1', 'Course 2'];
export const projects = ['Project 1', 'Project 2'];
export const modules = ['Module 1', 'Module 2', 'Module 3'];

export const EVALUATION_PARAMETERS = [
  'Overall',
  'Evaluation Mode',
  'Grouping Criteria',
];

export const PREFERENCES = ['email', 'sms', 'push', 'in_app_push'];

export const recentSearches = [
  { item: 'John Doe', module: 'Candidates' },
  { item: 'test', module: '' },
  { item: 'Angular', module: 'Courses' },
  { item: 'Jane', module: '' },
  { item: 'Rename', module: 'Questions' },
  { item: 'John Doe', module: 'Candidates' },
  { item: 'test', module: '' },
];

export const goToAll = [
  { component: 'Candidates', route: '/Operations/Candidate' },
  { component: 'Leads', route: '/Customer/Leads' },
  { component: 'Opportunities', route: '/Customer/Opportunities' },
];

export const searchResults = [
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
  { item: 'Test User 1', module: 'Candidates' },
  { item: 'Test Lead 1', module: 'Leads' },
  { item: 'Test 1', module: 'Question Bank' },
  { item: 'test11@gmail.com', module: '' },
  { item: 'test 21', module: 'Leads' }
];

export const searchResultsAll = [
  { item: 'Test User', module: 'Candidates' },
  { item: 'Test Lead', module: 'Leads' },
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
  { item: 'Test User 1', module: 'Candidates' },
  { item: 'Test Lead 1', module: 'Leads' },
  { item: 'Test 1', module: 'Question Bank' },
  { item: 'test11@gmail.com', module: '' },
  { item: 'test 21', module: 'Leads' },
  { item: 'Test User2', module: 'Candidates' },
  { item: 'Test Lead2', module: 'Leads' },
  { item: 'Test 2', module: 'Courses' },
  { item: 'test12@gmail.com', module: '' },
  { item: 'test 22', module: 'Leads' },
  { item: 'Test User3', module: 'Candidates' },
  { item: 'Test Lead3', module: 'Leads' },
  { item: 'Test3', module: 'Courses' },
  { item: 'test13@gmail.com', module: '' },
  { item: 'test 23', module: 'Leads' },
  { item: 'Test User', module: 'Candidates' },
  { item: 'Test Lead', module: 'Leads' },
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
  { item: 'Test User', module: 'Candidates' },
  { item: 'Test Lead', module: 'Leads' },
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
  { item: 'Test User', module: 'Candidates' },
  { item: 'Test Lead', module: 'Leads' },
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
  { item: 'Test User', module: 'Candidates' },
  { item: 'Test Lead', module: 'Leads' },
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
  { item: 'Test User', module: 'Candidates' },
  { item: 'Test Lead', module: 'Leads' },
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
  { item: 'Test User', module: 'Candidates' },
  { item: 'Test Lead', module: 'Leads' },
  { item: 'Test', module: 'Courses' },
  { item: 'test1@gmail.com', module: '' },
  { item: 'test 2', module: 'Leads' },
];

export const FOLDER_TYPES = {
  MOU: 'mou',
  LOGO: 'logo',
  CERTIFICATE: 'certificate',
  BILL: 'bill',
  RECEIPT: 'receipt',
  INVOICE: 'invoice',
  BLUEPRINT: 'blueprint',
  QUESTION_ATTACHMENTS: 'question_attachments',
  ASSESSMENT_PLAN: 'assessment_plan',
  USER_ATTACHMENTS: 'user_attachments',
};

export const CATEGORY_LIST = [
  { id: 'theory', name: 'theory' },
  { id: 'practical', name: 'practical' },
  { id: 'viva', name: 'viva' },
];

export const RUBRIC_LEGENDS = [
  { value: 'legend-0', viewValue: 'Bad , Good , Excellent' },
  { value: 'legend-1', viewValue: 'Bad, Good , Average , Excellent' },
  { value: 'legend-2', viewValue: 'Bad , Good' },
];

export const UNLISTED_KEYS = [
  'id',
  'spoc_ids',
  'business_vertical_id',
  'created_user_id',
  'geography_id',
  'industry_vertical_id',
  'modified_user_id',
  'organization_id',
  'pincode_id',
  'type_id',
  'product_id',
  'status_id',
  'item_ids',
  'user_role_id',
  'user_category_id',
  'role_id',
  'category_id',
];

export const extractKeys = {
  'Fill In The Blanks Question': [
    'id',
    'blank_indices_start_end_data',
    'blank_text_ans_key_data',
  ],
  'True/False Question': ['id', 'is_correct_option'],
  'Matching Questions': ['id', 'list_order_id', 'list_correct_sequence'],
  'Multiple Choice Question': ['id', 'is_correct_option'],
  'Subjective Answer Question': [
    'id',
    'answer_keywords',
    'evaluation_remarks',
    'sample_answer_for_reference',
  ],
  'Multi-select Question': ['id', 'is_correct_option'],
};



export const SEARCH_MODULES = {
  'Users': {
    fields: [
      { label: 'Full Name', value: 'users_full_name' },
      { label: 'Phone', value: 'users_phone' },
      { label: 'Email', value: 'users_email' },
      { label: 'Users ID', value: 'users_id' },
      { label: 'Organization ID', value: 'organization_id' },
      { label: 'Reporting To', value: 'users_reporting_to', fallback: 'None' },
      { label: 'Custom Attributes', value: 'users_cust_attr_values', fallback: 'None' },
      { label: 'Exclude Permissions', value: 'users_exclude_perm', fallback: 'None' }
    ],
    routerLink: '/UserSettings/Users'
  },
  'Scheme': {
    fields: [
      { label: 'Scheme Name', value: 'scheme_name' },
      { label: 'Scheme Code', value: 'scheme_code' },
      { label: 'Start Date', value: 'scheme_start_date' },
      { label: 'End Date', value: 'scheme_end_date' },
      { label: 'Funding Source', value: 'scheme_funding_source_name' },
      { label: 'Total Budget', value: 'scheme_total_budget_amount', pipe: 'currency' },
      { label: 'Scheme ID', value: 'scheme_id' },
      { label: 'Organization ID', value: 'organization_id' }
    ],
    routerLink: '/Customer/Scheme'
  },
  'Candidates': {
    fields: [
      { label: 'Candidate Name', value: 'candidate_full_name' },
      { label: 'Username', value: 'candidate_username' },
      { label: 'Email', value: 'candidate_email', fallback: 'Not provided' },
      { label: 'Candidate ID', value: 'candidate_id' },
      { label: 'Organization ID', value: 'organization_id' }
    ],
    routerLink: '/Operations/Candidate'
  },
  'Project': {
    fields: [
      { label: 'Project Alias', value: 'project_alias' },
      { label: 'Project Short Name', value: 'project_short_name' },
      { label: 'Description', value: 'project_description', fallback: 'No description provided' },
      { label: 'Project ID', value: 'project_id' },
      { label: 'Organization ID', value: 'organization_id' },
      { label: 'Created By User ID', value: 'project_created_user_id' }
    ],
    routerLink: '/Operations/Project'
  },
  'Courses': {
    fields: [
      { label: 'Course Name', value: 'course_name' },
      { label: 'Course Code', value: 'course_code' },
      { label: 'Description', value: 'course_description', fallback: 'No description available' },
      { label: 'Course Framework ID', value: 'course_framework_id' },
      { label: 'Course Group ID', value: 'course_group_id' },
      { label: 'Course Subgroup ID', value: 'course_subgroup_id' },
      { label: 'Course Active', value: 'course_is_active', pipe: 'yesNo' },
      { label: 'Course Created By User ID', value: 'course_created_user_id' }
    ],
    routerLink: '/Content/Courses'
  },
  'Customer': {
    fields: [
      { label: 'Customer Name', value: 'customer_name' },
      { label: 'Customer GSTIN', value: 'customer_gstin', fallback: 'Not provided' },
      { label: 'Customer PAN', value: 'customer_pan', fallback: 'Not provided' },
      { label: 'Customer Address', value: 'customer_address', fallback: 'Not provided' },
      { label: 'Customer ID', value: 'customer_id' },
      { label: 'Organization ID', value: 'organization_id' }
    ],
    routerLink: '/Customer/Customer'
  },
  'Questions': {
    fields: [
      { label: 'Question Text', value: 'questions_question_text' },
      { label: 'Question ID', value: 'questions_question_id' },
      { label: 'Question Paper Version ID', value: 'questions_qpv_id' },
      { label: 'Question Category', value: 'questions_question_category' }
    ],
    routerLink: '/Questions/Details'
  },
  'Leads': {
    fields: [
      { label: 'Lead Name', value: 'lead_name' },
      { label: 'Lead Address', value: 'lead_address' },
      { label: 'Lead Estimated Units', value: 'lead_estimated_units' },
      { label: 'Lead Estimated Revenue', value: 'lead_estimated_revenue', pipe: 'currency' },
      { label: 'Lead ID', value: 'lead_id' }
    ],
    routerLink: '/Customer/Leads'
  },
  'Rates': {
    fields: [
      { label: 'Customer Name', value: 'rates_customer_name' },
      { label: 'Service', value: 'rates_service' },
      { label: 'Unit of Measure', value: 'rates_uom' },
      { label: 'Unit Rate', value: 'rates_unit_rate' },
      { label: 'Effective From', value: 'rates_effective_from' },
      { label: 'Effective To', value: 'rates_effective_to' },
      { label: 'Active', value: 'rates_is_active', pipe: 'yesNo' }
    ],
    routerLink: '/Finance/RateMaster'
  },
  'Question Paper Version': {
  fields: [
    { label: 'Question Paper Version ID', value: 'question_paper_version_id' },
    { label: 'Name', value: 'question_paper_version_name' },
    { label: 'Short Name', value: 'question_paper_version_short_name' },
    { label: 'Question Paper Name', value: 'question_paper_version_question_paper_name' },
    { label: 'Count of Questions', value: 'question_paper_version_count_of_questions' },
    { label: 'Time Limit', value: 'question_paper_version_time_limit' },
    { label: 'Total Marks', value: 'question_paper_version_total_marks' },
    { label: 'Active', value: 'question_paper_version_is_active', pipe: 'yesNo' }
  ],
  routerLink: '/Content/QuestionPaperVersion'
},
'Assessment Plan': {
  fields: [
    { label: 'Assessment Plan ID', value: 'assessment_plan_id' },
    { label: 'Title', value: 'assessment_plan_title' },
    { label: 'Description', value: 'assessment_plan_description' },
    { label: 'Start Date & Time', value: 'assessment_plan_start_datetime' },
    { label: 'End Date & Time', value: 'assessment_plan_end_datetime' },
    { label: 'Tags', value: 'assessment_plan_tags' }
  ],
  routerLink: '/Operations/AssessmentPlan'
},
'Question Bank': {
  fields: [
    { label: 'Question Bank ID', value: 'question_bank_id' },
    { label: 'Title', value: 'question_bank_title' },
    { label: 'Course Framework Name', value: 'question_bank_course_framework_name' },
    { label: 'Course Name', value: 'question_bank_course_name' },
    { label: 'Active', value: 'question_bank_is_active', pipe: 'yesNo' },
    { label: 'Archived', value: 'question_bank_is_archived', pipe: 'yesNo' }
  ],
  routerLink: '/Content/QuestionBank'
},
'Industrial Vertical': {
  fields: [
    { label: 'Industrial Vertical ID', value: 'industrial_vertical_id' },
    { label: 'Name', value: 'industrial_vertical_name' },
    { label: 'Organization Name', value: 'industrial_vertical_organization_name' },
    { label: 'Active', value: 'industrial_vertical_is_active', pipe: 'yesNo' },
    { label: 'Created Date', value: 'industrial_vertical_created_datetime' },
    { label: 'Modified Date', value: 'industrial_vertical_modified_datetime' }
  ],
  routerLink: '/Organization/IndustrialVertical'
},
'Business Vertical': {
  fields: [
    { label: 'Business Vertical ID', value: 'business_vertical_id' },
    { label: 'Name', value: 'business_vertical_name' },
    { label: 'Code', value: 'business_vertical_code' },
    { label: 'Description', value: 'business_vertical_description' },
    { label: 'Organization Name', value: 'business_vertical_organization_name' },
    { label: 'Active', value: 'business_vertical_is_active', pipe: 'yesNo' }
  ],
  routerLink: '/Organization/BusinessVertical'
},
};


export const certiplate_logo = "data:image/png;base64,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"